import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=4e0a3e22"
import script from "./PrivacyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e0a3e22')) {
      api.createRecord('4e0a3e22', component.options)
    } else {
      api.reload('4e0a3e22', component.options)
    }
    module.hot.accept("./PrivacyPage.vue?vue&type=template&id=4e0a3e22", function () {
      api.rerender('4e0a3e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/privacy/PrivacyPage.vue"
export default component.exports